const state = {
  tempBalances: [],
  loadingTempBalance: false,
};

const getters = {
  tempBalances(state) {
    return state.tempBalances;
  },
  loadingTempBalance(state) {
    return state.loadingTempBalance;
  },
};

const mutations = {
  UPDATE_TEMP_BALANCES(state, tempBalances) {
    state.tempBalances = tempBalances;
  },
  UPDATE_LOADING_TEMP_BALANCE(state, loadingTempBalance) {
    state.loadingTempBalance = loadingTempBalance;
  },
};

const actions = {
  updateTempBalances({ commit }, tempBalances) {
    commit("UPDATE_TEMP_BALANCES", tempBalances);
  },
  updateLoadingTempBalances({ commit }, loadingTempBalance) {
    commit("UPDATE_LOADING_TEMP_BALANCE", loadingTempBalance);
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
